import type { Language } from "../../contexts/LanguageContext";
// Floating time: no timezone usage

export function formatWeekday(weekday: number, lang: Language): string {
  const index = Math.max(0, Math.min(6, Number(weekday)));
  const date = new Date(Date.UTC(2023, 0, 1 + index));
  return new Intl.DateTimeFormat(lang === 'pt' ? 'pt-BR' : 'en-US', {
    weekday: 'short',
  }).format(date);
}

export function formatTime(time: string, lang: Language): string {
  const [h = '0', m = '0'] = time.split(':');
  const date = new Date(1970, 0, 1, Number(h), Number(m));
  return new Intl.DateTimeFormat(lang === 'pt' ? 'pt-BR' : 'en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
}
